import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import AntdProForm, {
  ProFormText,
  ProFormTextArea,
  ProFormDigit,
  ProFormSelect,
  ProFormList,
  ProFormGroup,
} from '@ant-design/pro-form';
import { Switch } from 'antd';
// import { gql, useQuery } from '@apollo/client';
import fp from 'lodash/fp';
import { findDuplicateByKey, getMin } from '../../../../utils';
import ProForm from '../../../layout/ProForm';

const getDulicateSeq = fp.pipe(
  fp.get('approvalStepTemplates'),
  findDuplicateByKey('sequence'),
  fp.head,
  fp.get('sequence')
);
const getMinSeq = fp.pipe(fp.get('approvalStepTemplates'), getMin('sequence'));

// const GET_OPTIONS = gql`
//   query getOptions {
//     roles(state: ALL) {
//       id
//       name
//     }
//     faculties(state: ALL) {
//       id
//       name
//       abbreviation
//       departments {
//         id
//         name
//         abbreviation
//       }
//     }
//   }
// `;

const ApprovalRouteForm = ({ onFinish, initialValues, isEdit }) => {
  // const { data, loading } = useQuery(GET_OPTIONS);
  const [form] = AntdProForm.useForm();
  const [nextSeq, setNextSeq] = useState(0);

  useEffect(() => {
    setNextSeq(
      fp.pipe(
        fp.get('approvalStepTemplates'),
        fp.maxBy('sequence'),
        fp.get('sequence')
      )(initialValues) + 1 || 0
    );
  }, [initialValues]);

  return (
    <ProForm
      form={form}
      onFinish={onFinish}
      initialValues={initialValues}
      onValuesChange={() => {
        const values = form.getFieldsValue();
        setNextSeq(
          fp.pipe(
            fp.get('approvalStepTemplates'),
            fp.maxBy('sequence'),
            fp.get('sequence')
          )(values) + 1
        );
      }}
    >
      <ProFormText
        width="xl"
        name="name"
        label="Name"
        placeholder="name"
        rules={[
          {
            required: true,
            message: 'Please enter approval route template name!',
          },
        ]}
      />
      <ProFormTextArea
        width="xl"
        name="description"
        label="Description"
        placeholder="description (optional)"
      />
      {isEdit && (
        <AntdProForm.Item name="active" label="Active" valuePropName="checked">
          <Switch />
        </AntdProForm.Item>
      )}
      <ProFormList
        label="Approval Steps"
        name="approvalStepTemplates"
        creatorButtonProps={{
          creatorButtonText: 'Add',
          position: 'bottom',
          type: 'dashed',
        }}
        copyIconProps={false}
        deleteIconProps={{
          tooltipText: 'delete',
        }}
        creatorRecord={{
          sequence: nextSeq,
        }}
        rules={[
          {
            validator: async (_, approvalStepTemplates) => {
              if (!approvalStepTemplates || approvalStepTemplates.length < 1) {
                return Promise.reject(new Error('At least 1 step'));
              }
            },
          },
        ]}
      >
        <ProFormGroup>
          <ProFormDigit
            label="Sequence"
            name="sequence"
            width="sm"
            placeholder="sequence"
            min={0}
            rules={[
              {
                required: true,
                message: 'please enter',
              },
              ({ getFieldsValue }) => ({
                validator(_, value) {
                  const values = getFieldsValue();
                  const minseq = getMinSeq(values);

                  if (minseq !== 0) {
                    return Promise.reject(
                      new Error('sequence have to start with 0')
                    );
                  }
                  if (getDulicateSeq(values) === value) {
                    return Promise.reject(
                      new Error('cannot have the duplicate sequence')
                    );
                  }
                  return Promise.resolve();
                },
              }),
            ]}
          />
          <ProFormText
            width="sm"
            name="name"
            label="Name"
            placeholder="name"
            rules={[
              {
                required: true,
                message: 'Please enter approval route template name!',
              },
            ]}
          />
          <ProFormSelect
            label="Approver Listing Type"
            name="approverListingType"
            width="sm"
            placeholder="approverListingType"
            valueEnum={{
              HIERARCHY: 'Hierarchy',
              ASSIGN: 'Assign by PMS Admin',
            }}
            rules={[
              {
                required: true,
                message: 'please select',
              },
            ]}
          />
        </ProFormGroup>
      </ProFormList>
    </ProForm>
  );
};

ApprovalRouteForm.defaultProps = {
  initialValues: {},
  isEdit: false,
};

ApprovalRouteForm.propTypes = {
  onFinish: PropTypes.func.isRequired,
  isEdit: PropTypes.bool.isRequired,
  initialValues: PropTypes.object.isRequired,
};

export default ApprovalRouteForm;
